// extracted by mini-css-extract-plugin
export default {"numbers":"numbers___ee575a613d670e37","number":"number___a7f5fd1c2f61ee6e","selectedNumber":"selectedNumber___bd0e61093bc537ce"};